import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol, ContenedorBoton } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import global_axios  from '../../funciones_globales/interaccionapi';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { cargar_MovimientosCaja } from '../../actions/caja/act_caja02';
import { cargar_CuentasBancarias } from '../../actions/bancos/act_banc01';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import { validarFechaMomentEnFormatoString, validarCampoString } from '../../funciones_globales/utils';
import { formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { validarFechaTransaccionSeleccionada, validarPermisoAcceso } from '../../funciones_globales/utils';
import { getItemDatosSesion, getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

class FormBanco06 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            operacion: 'G',            
            fechaDesde: null,
            fechaHasta: null,
            
            lockGenDepositos: false,
            fechaDeposito: null,
            catalogoCtasBancarias: [],
            cuentaDep_sel: null,
            mvtosCajaPorDepositar: [],            

            columnsDefMovimientosPendDep: [               
                {   header: "No.",
                    field: "Nro",
                    width: 35,
                    type: "string",
                    suppressFilter: true,
                    pinned: true,
                },
                {   header: "Fecha",
                    field: "Vencimiento",
                    width: 75,
                    type: "string",
                    pinned: true,
                },
                {   header: "Cliente",
                    field: "Cliente",
                    width: 200,
                    type: "string",
                    pinned: true,
                },
                {   header: "Valor",
                    field: "Valor",
                    width: 75,
                    type: "num_decimal",
                    pinned: true
                },
                {   header: "Referencia",
                    field: "Referencia",
                    width: 90,
                    type: "string"
                },
                {   header: "Tipo",
                    field: "TipoAutoCaja",
                    width: 60,
                    type: "string"
                },
                {   header: "Mov. Caja",
                    field: "MovCaja",
                    width: 85,
                    type: "string"
                },
                {   header: "Observación",
                    field: "Observacion",
                    width: 140,
                    type: "string"
                },
                {   header: "No. Comprobante",
                    field: "Comprobante",
                    width: 80,
                    type: "string",
                    editable: true,
                    suppressSorting: true,
                    suppressMenu: true,
                    suppressFilter: true
                },
                {   header: "Mov. Banco",
                    field: "MovBanco",
                    width: 80,
                    type: "string",
                    suppressSorting: true,
                    suppressMenu: true,
                    suppressFilter: true,
                    cellStyle: {color: 'red', 'font-weight': 700}
                },
            ],
        }

        this.gridMovimientosPendDepOptions = {
            enableColResize: true,
            enableSorting: true,
            enableFilter: true,
            rowSelection: 'multiple',
            suppressRowClickSelection: true,
            singleClickEdit: true
        };
        
        this.handleInputChange = this.handleInputChange.bind(this);
        this.limpiarMovCajaPorDep = this.limpiarMovCajaPorDep.bind(this);        
        this.procesarDepositos = this.procesarDepositos.bind(this);
        this.onGridMovimientosPendDep = this.onGridMovimientosPendDep.bind(this);
        this.buscarMvtosEfectivoPendDeposito = this.buscarMvtosEfectivoPendDeposito.bind(this);
    }

    onGridMovimientosPendDep(params){
        this.apiGridMovPendDep = params.api;
        this.columnApiGridMovPendDep = params.columnApi;
    }
  
    componentDidMount(){
        Promise.all([            
            this.props.generar_LogAuditoriaIngresoForm('0706'),
            this.props.cargar_CuentasBancarias('CC')
        ])
        .then(()=>{
            let cuentasBancarias = this.props.cuentasBancarias;
            let catalogoCtasBancarias = [];
            cuentasBancarias.forEach(item => {                
                catalogoCtasBancarias.push({value: item.Cuenta, label: `${item.Nombre.toString().trim().toUpperCase()} (${item.Numero.toString().trim()})`});                
            });
            
            let fechaProceso = getFechaProcesoPorModulo('07');

            this.setState({ fechaDeposito: moment(fechaProceso, 'DD/MM/YYYY'),
                            fechaDesde: moment(fechaProceso, 'DD/MM/YYYY'),
                            fechaHasta: moment(fechaProceso, 'DD/MM/YYYY'),
                            catalogoCtasBancarias
            });
        })
        .catch(error => {
            alert(error.response?error.response.data.msg:error.message);
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0706');
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    limpiarMovCajaPorDep(){
        let fechaProceso = getFechaProcesoPorModulo('07');
        this.setState({            
            fechaDesde: moment(fechaProceso, 'DD/MM/YYYY'),
            fechaHasta: moment(fechaProceso, 'DD/MM/YYYY'),
            fechaDeposito: moment(fechaProceso, 'DD/MM/YYYY'),
            cuentaDep_sel: null,
            mvtosCajaPorDepositar: [],
            lockGenDepositos: false
        });
    }    

    buscarMvtosEfectivoPendDeposito(){
        let fechaDesde;
        let fechaHasta;

        if(!validarFechaMomentEnFormatoString(formatearFechaMoment_a_String(this.state.fechaDesde))){
            alert('La fecha Desde es inválida.');
            return;
        }
        
        if(!validarFechaMomentEnFormatoString(formatearFechaMoment_a_String(this.state.fechaHasta))){
            alert('La fecha Hasta es inválida.');
            return;
        }

        if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0){
            alert('La fecha Desde no puede ser mayor que la fecha Hasta.');
            return;
        }
        
        fechaDesde = formatearFechaMoment_a_String(this.state.fechaDesde);
        fechaHasta = formatearFechaMoment_a_String(this.state.fechaHasta);

        this.props.cargar_MovimientosCaja('efectivoPendDeposito=S', fechaDesde, fechaHasta)
        .then(()=>{
            let mvtosCajaPorDepositar = [];

            this.props.mvtosEfectivoPendDep.forEach(movCajaEfect=>{                
                mvtosCajaPorDepositar.push({
                    ...movCajaEfect,
                    MovCaja: movCajaEfect.Movimiento,
                    Observacion: movCajaEfect.Concepto,
                    Comprobante: null
                });
            });

            this.setState({mvtosCajaPorDepositar, lockGenDepositos: false});
        });
    }

    procesarDepositos(){

        let validPermiso = validarPermisoAcceso(this.state.operacion, this.props.permiso);
        if (!validPermiso.esValido){
            alert(validPermiso.msg);
            return;
        }

        if (this.state.mvtosCajaPorDepositar.length === 0){
            alert('Ud. no ha seleccionado los movimientos de efectivo que va a depositar.');
            return;
        }

        let loteMvtosEfectADepositar = {};
        let mvtosEfectADepositar = [];

        this.state.mvtosCajaPorDepositar.forEach(movCajaEf=>{
            if (validarCampoString(movCajaEf.Comprobante, 1, 12)){
                mvtosEfectADepositar.push({
                    concepto: `D. EFEC ${movCajaEf.Cliente} - MCAJ: ${movCajaEf.MovCaja}`,
                    referencia: movCajaEf.Comprobante,
                    valor: movCajaEf.Valor,
                    codCliente: movCajaEf.Cliente.substr(0, 7),
                    indEfectivo: '1',
                    movCaja: movCajaEf.MovCaja,
                    fechaVcto: movCajaEf.Vencimiento,
                    tipoAutoCaja: movCajaEf.TipoAutoCaja.substr(0, 3)
                });
            }
        });

        if(mvtosEfectADepositar.length===0){
            alert('Ud. no ha seleccionado los movimientos de efectivo que va a depositar.');
            return;
        }

        if(this.state.cuentaDep_sel === null){
            alert('No ha seleccionado la cuenta bancaria a depositar.');
            return;
        }

        if(!validarFechaMomentEnFormatoString(formatearFechaMoment_a_String(this.state.fechaDeposito))){
            alert('La fecha Depósito es inválida.');
            return;
        }       

        let fechaProceso = getFechaProcesoPorModulo('07');
        if (this.props.permiteCambioFProceso==='S'){
            let validFProceso = validarFechaTransaccionSeleccionada(this.state.fechaDeposito, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
            
            if(!validFProceso.esValida){
                alert(validFProceso.msg);
                return;
            }
        }
        
        loteMvtosEfectADepositar = {
            depositosEnLote: true,
            cuenta: this.state.cuentaDep_sel,
            fechaDeposito: formatearFechaMoment_a_String(this.state.fechaDeposito),
            mvtosEfectADepositar,
            usuario: getItemDatosSesion('usuario').toString(),
            moneda:  JSON.parse(getItemDatosSesion('moneda')).Moneda,
            dolar: JSON.parse(getItemDatosSesion('moneda')).Cotizacion,
            planVigente: getItemDatosSesion('planVigente')
        }
        
        this.props.cambiar_VisualizacionLoading(true);

        global_axios({
            method: 'POST',
            url: '/depositos',
            data: loteMvtosEfectADepositar
        })
        .then(response=>{
            
            this.props.cambiar_VisualizacionLoading(false);
            alert('Se ejecutó correctamente el proceso de generación de depósitos.');
            
            let movsBancoGenerados = response.data.movsGenerados;
            let mvtosCajaDepositados = [];

            movsBancoGenerados.forEach(itemMovBanco=>{                
                this.state.mvtosCajaPorDepositar.forEach(movCajaEf=>{
                    if(itemMovBanco.MovCaja === movCajaEf.MovCaja){
                        mvtosCajaDepositados.push({
                            ...movCajaEf,
                            MovBanco: itemMovBanco.MovBanco
                        });
                    }
                });
            });
            
            this.setState({mvtosCajaPorDepositar: mvtosCajaDepositados, lockGenDepositos: true});
        })
        .catch(error => {
            this.props.cambiar_VisualizacionLoading(false);
            alert(error.response?error.response.data.msg:error.message);
        });
    }    

    render(){       

        return(
            <ContenedorForm porc_ancho={70}>
                <HeaderForm>
                    <TituloForm>Depósito Masivo de Efec/Dep de Cobranza</TituloForm>
                </HeaderForm>
                <CuerpoForm>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <Row>
                                <ContainerCol className='col-sm-12'>
                                    <LabelForm>Efectivo/Depósito pendiente de depositar:</LabelForm>
                                </ContainerCol>
                            </Row>
                            <Row>
                                <ContainerCol className='col-sm-3'>
                                    <LabelForm>Fecha Desde:</LabelForm>
                                    <PickerFecha fechaSeleccionada={this.state.fechaDesde}
                                        func_onChange={(fecha)=>{this.setState({fechaDesde: fecha})}}/>
                                </ContainerCol>
                                <ContainerCol className='col-sm-3'>
                                    <LabelForm>Fecha Hasta:</LabelForm>
                                    <PickerFecha fechaSeleccionada={this.state.fechaHasta}
                                        func_onChange={(fecha)=>{this.setState({fechaHasta: fecha})}}/>
                                </ContainerCol>
                                <ContainerCol className='col-sm-1'>
                                    <ContenedorBoton margen_arriba={20}>
                                        <Tooltip placement="right" overlay='Buscar movimientos de efectivo pendientes de depositar'>
                                            <button type='button' className='btn btn-success btn-sm' 
                                                onClick={this.buscarMvtosEfectivoPendDeposito}>
                                                <i className='fa fa-search'></i>
                                            </button>
                                        </Tooltip>
                                    </ContenedorBoton>
                                </ContainerCol>
                            </Row>
                            <Row>
                                <ContainerCol className='col-sm-12'>
                                    <AgGridRender altura='300px' data={this.state.mvtosCajaPorDepositar} columnas={this.state.columnsDefMovimientosPendDep}
                                    gridOptions={this.gridMovimientosPendDepOptions} onGridReady={this.onGridMovimientosPendDep}/>
                                </ContainerCol>
                            </Row>
                            <Row>
                                <ContainerCol className='col-sm-5'>
                                    <LabelForm>Cuenta a Dep.:</LabelForm>
                                    <ReactSelect options={ this.state.catalogoCtasBancarias } value={this.state.cuentaDep_sel} func_onChange={(value)=>{this.setState({cuentaDep_sel: value===null?null:value.value})}}/>
                                </ContainerCol>
                                <ContainerCol className='col-sm-3'>
                                    <LabelForm>Fecha Depósito:</LabelForm>
                                    <PickerFecha fechaSeleccionada={this.state.fechaDeposito} disabled={!(this.props.permiteCambioFProceso==='S')}
                                        func_onChange={(fecha)=>{this.setState({fechaDeposito: fecha})}}/>
                                </ContainerCol>
                            </Row>
                            <Row>
                                <ContainerCol className='col-sm-12' margen_arriba={25}>
                                    <div className='btn-group pull-right'>
                                        <button type='button' className='btn btn-primary btn-sm' onClick={this.procesarDepositos} disabled={this.state.lockGenDepositos}>
                                            <i className='fa fa-floppy-o fa-lg'/> Guardar Depósito(s)</button>
                                        <button type='button' className='btn btn-sm' onClick={this.limpiarMovCajaPorDep}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
                                    </div>
                                </ContainerCol>
                            </Row>
                        </ContainerCol>                       
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {    permiso: state.sesion.valoresSesionForm.Permiso,
                idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
                mvtosEfectivoPendDep: state.caja.mvtosCaja,
                cuentasBancarias: state.bancos.cuentasBancarias,
                permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
                diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias
        }
});
  
const mapDispatchToProps = ((dispatch) => {
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm,
                            cambiar_VisualizacionLoading, cargar_MovimientosCaja, cargar_CuentasBancarias }, dispatch)
});
  
export default connect(mapStateToProps, mapDispatchToProps)(FormBanco06);